// src/lib/sprache.js
// --- SPRACHE DER ANZEIGE -------------------------------------------------------
//
// Anna-Lena 14.09.2026: "Können wir auch verschiedene Sprachen anbieten, z. B.
// Kroatisch?" Begonnen mit Kroatisch, zuerst fuer die Protokoll-Erfassung.
//
// Grundregeln:
//   - NUR die Anzeige wird uebersetzt. Gespeichert wird immer deutsch
//     ("i.O.", "n.i.O.", Gruende ...) - Logik, Maengel, Buero und PDF bleiben
//     unveraendert.
//   - Schluessel ist der deutsche Text selbst: t('Speichern'). Fehlt eine
//     Uebersetzung, erscheint einfach der deutsche Text - nie etwas Leeres.
//   - Platzhalter: t('{n} Eingaben warten auf Netz.', { n: 3 }).
//   - Die Wahl gilt je Geraet (localStorage), jeder Monteur stellt selbst um.

import { useEffect, useState } from 'react';
import { UI_HR } from './uebersetzungen/hr-ui';
import { PRUEFPUNKTE_HR, OPTIONEN_HR, MODULE_HR, KATEGORIEN_HR, ZUSATZ_HR } from './uebersetzungen/hr-pruefpunkte';
import { INFO_HR, MODUL_INFO_HR } from './uebersetzungen/hr-info';

export const SPRACHEN = [
  { code: 'de', name: 'Deutsch' },
  { code: 'hr', name: 'Hrvatski (Kroatisch)' },
];

const SCHLUESSEL = 'etb-sprache';
const WOERTERBUCH = {
  hr: {
    ui: UI_HR, pruefpunkte: PRUEFPUNKTE_HR, optionen: OPTIONEN_HR, module: MODULE_HR,
    kategorien: KATEGORIEN_HR, zusatz: ZUSATZ_HR, info: INFO_HR, modulInfo: MODUL_INFO_HR,
  },
};

let aktuell = (() => {
  try {
    const s = localStorage.getItem(SCHLUESSEL);
    return WOERTERBUCH[s] ? s : 'de';
  } catch { return 'de'; }
})();
const horcher = new Set();

export function sprache() { return aktuell; }

export function setzeSprache(code) {
  aktuell = WOERTERBUCH[code] ? code : 'de';
  try { localStorage.setItem(SCHLUESSEL, aktuell); } catch { /* egal */ }
  try { document.documentElement.lang = aktuell; } catch { /* egal */ }
  horcher.forEach(cb => { try { cb(aktuell); } catch { /* egal */ } });
}

// Komponenten, die sich bei einem Sprachwechsel neu zeichnen sollen.
export function useSprache() {
  const [code, setCode] = useState(aktuell);
  useEffect(() => {
    const cb = (c) => setCode(c);
    horcher.add(cb);
    return () => horcher.delete(cb);
  }, []);
  return code;
}

const buch = () => WOERTERBUCH[aktuell] || null;
const norm = (s) => String(s ?? '').replace(/\s+/g, ' ').trim();

function einsetzen(text, werte) {
  if (!werte) return text;
  return String(text).replace(/\{(\w+)\}/g, (m, k) => (werte[k] !== undefined ? String(werte[k]) : m));
}

// Oberflaechen-Text.
export function t(text, werte) {
  const b = buch();
  const uebersetzt = b ? (b.ui[text] ?? b.ui[norm(text)]) : null;
  return einsetzen(uebersetzt || text, werte);
}

// Bezeichnung / Beschreibung eines Pruefpunkts (feld: 'bezeichnung' | 'beschreibung').
export function ppText(modulCode, pp, feld) {
  const b = buch();
  const deutsch = pp?.[feld];
  if (!b || !pp) return deutsch;
  const e = b.pruefpunkte[modulCode + '|' + String(pp.pos_nummer || '').trim()];
  return (e && e[feld]) || deutsch;
}

// Antwort-Option oder Grund. Gespeichert bleibt der deutsche Wert!
export function optionText(opt) {
  const b = buch();
  if (!b) return opt;
  return b.optionen[opt] || b.optionen[norm(opt)] || b.ui[norm(opt)] || opt;
}

export function modulName(code, deutsch) {
  const b = buch();
  return (b && b.module[code]) || deutsch;
}

export function kategorieText(k) {
  const b = buch();
  return (b && (b.kategorien[k] || b.kategorien[norm(k)] || b.ui[norm(k)])) || k;
}

export function zusatzLabel(label) {
  const b = buch();
  return (b && (b.zusatz[label] || b.zusatz[norm(label)] || b.ui[norm(label)])) || label;
}

// i-Texte in der gewaehlten Sprache (null = deutsche verwenden).
export function infoInSprache(schluessel) {
  const b = buch();
  return b ? (b.info[schluessel] || null) : null;
}
export function modulInfoInSprache(code) {
  const b = buch();
  return b ? (b.modulInfo[code] || null) : null;
}
